import PriceChange from "common/Charts/PriceChange";
import React from "react";
import { isNumber } from "lodash";
import useGraphDataSocket from "@shared/services/socket/useGraphDataSocket";

interface LivePriceChangeProps {
  symbol: string;
  exchange: string;
  initialChange: number;
  size: number;
  useBackground?: boolean;
}

const LivePriceChange = ({
  symbol,
  exchange,
  initialChange,
  size,
  useBackground = false,
}: LivePriceChangeProps) => {
  const { change: socketChange } = useGraphDataSocket(symbol, exchange);
  let change = socketChange ?? initialChange;
  if (isNumber(change)) change = change * 100;
  return (
    <PriceChange change={change} size={size} useBackground={useBackground} />
  );
};

export default LivePriceChange;
